import { Component, EventEmitter, OnInit, Output } from "@angular/core";

@Component({
    selector: "adapt-eula",
    templateUrl: "./eula.component.html",
    styleUrl: "./eula.component.css",
    standalone: false,
})
export class EulaComponent implements OnInit {
    public loaded = false;

    @Output() public loadedChange = new EventEmitter<boolean>();

    public onLoaded() {
        this.loaded = true;
        this.loadedChange.emit(true);
    }

    public ngOnInit() {
        this.onLoaded();
    }
}
